'use client';
import styled from 'styled-components';

export const StyledSimplifiedHero = styled.div`
  background-color: ${props =>
    props.theme.colors.get(
      props.$backgroundColor,
      props.theme.colors.background.base,
    )};
  color: ${props => props.theme.colors.text.secondary};
  padding: ${props =>
    props.$mobilePadding
      ? props.theme.spacing(props.$mobilePadding, 0)
      : props.theme.spacing(13, 0)};
  @media ${props => props.theme.tablet} {
    padding: ${props =>
      props.$desktopPadding
        ? props.theme.spacing(props.$desktopPadding, 0)
        : props.theme.spacing(12, 0, 14)};
  }
`;

export const EyebrowWrapper = styled.div`
  margin: 0 auto;
  max-width: 870px;
  padding: ${props => props.theme.spacing(0, 5)};
  width: 100%;
  text-align: ${props => props.$textAlignment || 'center'};
`;

export const ButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 870px;
  padding: ${props => props.theme.spacing(0, 5)};
  box-sizing: border-box;
  margin: 40px auto 0 auto;
  justify-content: ${props =>
    props.theme.getJustifyContent(props.$textAlignment)};
  ${props => props.theme.getFocusOutline(props.$backgroundColor)}
`;
